import styled from "styled-components"

export const ModalWrapper = styled.div`

.amid {
    &_overlay {
        display: block;
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: rgba(1, 1, 1, 35%);
        z-index: 10;
        transition: all 0.3s linear;
    }
    &_container {
        position: fixed;
        top: 42px;
        left: 25%;
        min-height: 200px;
        width: 1020px;
        background-color: #fff;
        border-radius: 4px;
        padding: 12px;
        z-index: 20;
        transition: all 0.3s linear;
    }
    
    &_header {
        font-size: 1.4rem;
        text-align: center;
        border-bottom: 1px solid #e2c1c1;
        padding-bottom: 8px;
    }
    &_list {
        max-height: 80vh;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    &_item {
        margin: 4px;
        position: relative;
        &_delete {
            position: absolute;
            right: 10px;
            top: 10px;
            background-color: #ff6801;
            width: 25px;
            height: 25px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            cursor: pointer;
            &:hover {
                background-color: #fd475a;
            }
            i {
                color: #fff;
                font-size: 0.9rem;
            }
        }
        &_add {
            background-color: #e9e9e9;
            cursor: pointer;
            &:hover {
                background-color: #65d9dd;
            }
            i {
                font-size: 3.6rem;
                color: #ff6801;
            }
        }
    }
    &_box {
        width: 240px;
        height: 180px;
        border: 1px solid #e2c1c1;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            width: auto;
            max-width: 100%;
            min-width: 80%;
            height: auto;
            max-height: 100%;
        }
    }
    &_footer {
        display: flex;
        justify-content: flex-end;
        margin-top: 22px;
        padding-top: 15px;
        padding-bottom: 15px;
        height: 60px;
        border-top: 1px solid #e2c1c1;
        div {
            display: flex;
            input {
                margin-left: 25px;
                height: 35px;
                width: 250px;
                padding: 0 8px;
                border: 1px solid #e2c1c1;
                outline: none;
                border-radius: 4px;
                &:focus {
                    border: 1px solid #626060;
                }
            }
            button {
                background-color: #ff6801;
                &:hover {
                    background-color: #fd475a;
                }
            }
        }
        button {
            margin-left: 12px;
            width: 120px;
            border: none;
            outline: none;
            color: #fff;
            height: 35px;
            i {
                margin-right: 4px;
            }
            background-color: #469ef4;
            &:hover {
                background-color: #2f80ed;
            }
        }
    }
}

`
